import React from 'react';

const StarLawyerCard = ({ starLawyer }) => {
    return (
        <div className='star_lawyer'>
            <img src={starLawyer.src} alt="" className="star_lawyer-image" />
            <div className="star_lawyer-data">
                <h1 className="star_lawyer-name">{starLawyer.name}</h1>
                <h3 className="star_lawyer-specialisation">{starLawyer.specialisation}</h3>
                <p className="star_lawyers-description">{starLawyer.description}</p>
            </div>
        </div>
    );
}

export default StarLawyerCard;
